import React from 'react';
import PropTypes from 'prop-types';
import {
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import MainContentWrapper from '../Layouts/MainContent/mainContent';
import { DrawerProvider } from '../Contexts/DrawerContext';
import { useAuth } from '../Contexts/AuthContext';

// import { LoginPage } from '../Pages/LoginPage/LoginPage';
import { Landing } from '../Pages/Landing/landing';
// import { RegisterPage } from '../Pages/Landing/RegisterPage';
// import { PropertyDetailsPage } from '../Pages/PropertyDetails/PropertyDetailsPage';
import Property from '../Pages/Properties/property';
import PropertyList from '../Pages/PropertyDashboard/propertyList';
import StandaloneReviewPropertyDetails from '../Pages/Properties/viewPropertyDetails';
import UserManagement from '../Pages/UserManagement/UserManagement';

// ✅ PrivateRoute component for redirection
const PrivateOutlet = () => {
  const { isLoggedIn, loading } = useAuth();
  const location = useLocation();

  console.log('PrivateOutlet - checking authentication:', { isLoggedIn, loading });

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return isLoggedIn
    ? <Outlet />
    : <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
};

// ✅ Authenticated layout wrapper
const AuthenticatedLayout = ({ children, hideHeaderOnDesktop = false }) => (
  <DrawerProvider>
    <MainContentWrapper hideHeaderOnDesktop={hideHeaderOnDesktop}>
      {children || <Outlet />} {/* Fix: fallback to <Outlet /> if children is undefined */}
    </MainContentWrapper>
  </DrawerProvider>
);

AuthenticatedLayout.propTypes = {
  children: PropTypes.node,
  hideHeaderOnDesktop: PropTypes.bool,
};

const AdminOutlet = () => {
  const { user, userProfile } = useAuth();
  const roleId = user?.role_id ?? user?.roleId ?? userProfile?.role_id ?? userProfile?.roleId;
  const isAdmin = Number(roleId) === 1;

  return isAdmin ? <Outlet /> : <Navigate to="/my-properties" replace />;
};

const Routers = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Landing />} />
      {/* Note: /login, /register, /property/:id routes are now handled in App.js */}

      {/* Protected Routes with layout */}
      <Route element={<PrivateOutlet />}>
        <Route element={<AuthenticatedLayout />}>
          <Route path="/property-details" element={<Property />} />
          <Route path="/property-view" element={<StandaloneReviewPropertyDetails />} />
        </Route>

        <Route element={<AuthenticatedLayout hideHeaderOnDesktop />}>
          <Route path="/property-list" element={<PropertyList />} />
          <Route element={<AdminOutlet />}>
            <Route path="/users" element={<UserManagement />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default Routers;

